export default __webpack_public_path__ + "static/media/Orchha_Fort.664870c1.jpg";